import { LinkAccounts } from './myLinkAccounts';

require('./myLinkAccounts.scss');

export const myLinkAccounts = {
  template: require('./myLinkAccounts.html'),
  controllerAs: 'ctrl',
  controller: LinkAccounts,
};
